import { UPDATE_I18N } from "../constants/appConstants";

export const i18n = (state = "", action) => {
  switch (action.type) {
    case UPDATE_I18N:
      return action.payload;
    default:
      return state;
  }
};
